export default __webpack_public_path__ + "static/media/TFO-Yarn-Waxing.6c3a4417.jpg";